<template>
<div class="media-center-main">
  很抱歉，本网站电脑端不可用，烦请用手机打开。
</div>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style lang="less" scoped>
.media-center-main {
  margin: 0 auto;
  width: 1200px;
  text-align: center;
  padding: 25vh 0;
}
</style>